module.exports = __webpack_public_path__ + "media/svg/om-ce783269.svg";